import { getNextEdgeIndex } from './getNextEdgeIndex';

import { getInterceptPoint } from '~/core/helpers';
import { DrawingEdge, DrawingShape } from '~/core/models';

export const setRadiiCenterPoints = (
  shape: DrawingShape,
  edge: DrawingEdge,
  edgeIndex: number
) => {
  const endPt = shape.cornerMap[edge.endCornerId];
  const nextEdgeIndex = getNextEdgeIndex(shape, edgeIndex);

  //find radius center point by using the respective start and end display points on the adjacent edges
  if (endPt.size && endPt.size > 0.75 && endPt.isVisibleInCanvas) {
    const intersectionPt = getInterceptPoint(
      edge.endDisplayVec,
      edge.normalVec,
      shape.drawingEdges[nextEdgeIndex].startDisplayVec,
      shape.drawingEdges[nextEdgeIndex].normalVec,
      true
    );

    endPt.radiusCenterPoint = intersectionPt ?? undefined;
  }
};
